// Register only the Chart.js pieces we actually use, then re-export the
// component wrappers. Centralizing this avoids duplicate registration and
// lets us drop unused chart types from the bundle.

import {
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  BarController,
  BarElement,
  CategoryScale,
  Filler,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
);

export { ChartJS };
